/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { DraftCreateMetaSchema } from './DraftCreateMetaSchema';
import { DraftMeta } from './DraftMeta';

export const DraftCreate: core.serialization.ObjectSchema<serializers.DraftCreate.Raw, Truvity.DraftCreate> =
    core.serialization.object({
        jsonLdVocabs: core.serialization.property(
            'json_ld_vocabs',
            core.serialization.list(core.serialization.string()).optional(),
        ),
        meta: DraftMeta.optional(),
        metaSchema: core.serialization.property('meta_schema', DraftCreateMetaSchema),
        values: core.serialization.lazy(() => serializers.CredentialClaimValues).optional(),
        vcdmJsonSchemas: core.serialization.property(
            'vcdm_json_schemas',
            core.serialization.list(core.serialization.string()).optional(),
        ),
    });

export declare namespace DraftCreate {
    export interface Raw {
        json_ld_vocabs?: string[] | null;
        meta?: DraftMeta.Raw | null;
        meta_schema: DraftCreateMetaSchema.Raw;
        values?: serializers.CredentialClaimValues.Raw | null;
        vcdm_json_schemas?: string[] | null;
    }
}
